/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Backdrop, Grid,Typography } from '@mui/material'
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { BtnConfirm, BtnHome } from 'components/Common/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import {
    loadCaptchaEnginge,
    LoadCanvasTemplate,
    validateCaptcha
} from 'react-simple-captcha';
import PopUpCustom from 'components/PopupCustom/PopUpCustom';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import { AlertMsg, AlertTitle, AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import { i18n } from 'i18n';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
const i18nField = 'entities.Dialogforgot.fields';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DialogForgetPassword = (props) => {

    const { open, setOpen } = props;
    const { BlockUI, UnBlockUI } = FnBlock_UI();

    const Layout900 = useMediaQuery('(min-width:900px)');
    const [IsSaveProgress, setIsSaveProgress] = useState(false)
    const [openBackDrop, setOpenBackDrop] = React.useState(false);

    const schema = yup.object().shape({
        sEmail: yupFormSchemas.email(i18n(`${i18nField}.sEmail`), { required: true }),
        sCaptchaforgot: yupFormSchemas.string(i18n(`${i18nField}.sRegis`), { required: true }),
    });

    const formforgot = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        
        if (open === true) {
            
            loadCaptchaEnginge(6);
            Object.keys(formforgot.getValues()).forEach((key => {
                formforgot.setValue(key, null);
                formforgot.clearErrors(key);
            }))
        }
    }, [open])

    const onCheckCaptcha = () => {
        let sCaptcha = formforgot.getValues("sCaptchaforgot");

        if (validateCaptcha(sCaptcha) === true) {
            return true;
        } else {
            loadCaptchaEnginge(6);
            formforgot.setValue("sCaptchaforgot", "")
            return false;
        }
    }

    const onForgotPassword = () => {

        let chkCatpcha = onCheckCaptcha();
        if (chkCatpcha) {
            //popup save
            let param = {
                "sEmail": formforgot.getValues("sEmail") ?? null,
            }
            SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.confirm, () => {
                setOpen(false)
                setOpenBackDrop(true)
                AxiosPost(`Authentication/ResetPassword`, param, (res) => {
                    setOpenBackDrop(false)
                    ResultAPI(res, null, () => {
                        if (res.statusCode === 200) {

                            if(res.Message == "Nodata")
                            {
                                SwAlert.Warning(AlertTitle.Warning, i18n(`${i18nField}.sNoEmailUser`), () => { });
                            }
                            else
                            {
                                setIsSaveProgress(true)
                            }
                        }
                        else {
                            SwAlert.Warning(AlertTitle.Warning, res.Message, () => { });
                        }
                    })
                }, null, null)
            })
        }
    }

    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => { setOpen(!open) }}
                maxWidth={"xs"}
                fullWidth
                aria-describedby="form-forgot"
            >
                <DialogTitle>
                    <Grid container spacing={1} direction="row" justifyContent="start" alignItems="center">
                        <Grid item >
                            <Typography style={{ color: "#000000", fontSize: "25px", fontWeight: "bold" }}>
                                {i18n(`${i18nField}.sForgotPassword`)}
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent style={{ paddingTop: '10px' }}>
                    {
                        open ?
                            <FormProvider {...formforgot}>
                                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start">
                                    {/* sEmail  */}
                                    <Grid item xs={12} >
                                        <InputFormItem
                                            id="sEmail"
                                            name="sEmail"
                                            label={i18n(`${i18nField}.sEmail`)}
                                            required={true}
                                            fullWidth
                                        />
                                    </Grid>
                                    {/* captcha  */}
                                    <Grid item xs={12}>
                                        <div style={{ textAlign: 'center', background: 'radial-gradient(circle, rgba(255,255,255,1) 32%, rgba(130,209,242,1) 100%)', padding: '16px', borderRadius: '5px' }}>
                                            <LoadCanvasTemplate
                                                reloadText= {currentLanguage() == "th" ? "รีเฟรช" : "Refresh"}
                                                reloadColor="black"
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputFormItem
                                            id="sCaptchaforgot"
                                            name="sCaptchaforgot"
                                            label={i18n(`${i18nField}.sRegis`)}
                                            required={true}
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            </FormProvider>
                            : null
                    }
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                        <Grid item >
                            <BtnConfirm txt={i18n(`${i18nField}.sConfirm`)} onClick={formforgot.handleSubmit(() => { onForgotPassword() })} />
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            <PopUpCustom
                setIsOpen={setIsSaveProgress}
                IsOpen={IsSaveProgress}
                sMaxWidth={'sm'}
                JsxDialogHeader={
                    <>
                        <Typography>{i18n(`${i18nField}.sReportResults`)}</Typography>
                    </>
                }
                JsxDialogContent={
                    <>
                        <Typography>{i18n(`${i18nField}.sContent`)}</Typography>
                    </>
                }
                JsxDialogAction={
                    <>
                        <Grid container direction="row" justifyContent="end" alignItems="center">
                            <Grid item >
                                <BtnHome
                                    // txt={currentLanguage() == "th" ? "กลับสู่หน้าหลัก" : "Home page"}
                                    txt={i18n(`${i18nField}.sClose`)}
                                    onClick={() => {
                                        setIsSaveProgress(false)
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </>
                }
            />
             <Backdrop
                sx={{ color: '#fff', zIndex: 99999 }}
                open={openBackDrop}
            >
                <div className="spinner">
                    <span className="ball-1"></span>
                    <span className="ball-2"></span>
                    <span className="ball-3"></span>
                    <span className="ball-4"></span>
                    <span className="ball-5"></span>
                    <span className="ball-6"></span>
                    <span className="ball-7"></span>
                    <span className="ball-8"></span>
                </div>
            </Backdrop>
        </>
    )
}

export default DialogForgetPassword